export function universalBtoa(str: string) {
  try {
    return btoa(str);
  } catch (err: any) {
    return Buffer.from(str).toString('base64');
  }
}

export function universalAtob(b64Encoded: string) {
  try {
    return atob(b64Encoded);
  } catch (err: any) {
    return Buffer.from(b64Encoded, 'base64').toString();
  }
}
